import React from 'react';
import {Table as BaseTable} from 'desktop/sports/mma/players-list/classic';

class Table extends BaseTable {}

export {Table};
